import { Link } from "@inertiajs/react";
import { Heart } from "lucide-react";

export default function EmptyWishlist() {
  return (
    <div className="rounded-[2rem] border border-border bg-neutral-100/30 px-6 py-20 text-center">
      <div className="mx-auto flex size-16 items-center justify-center rounded-full bg-white shadow-lg">
        <Heart className="size-7" />
      </div>

      <h2 className="mt-6 text-3xl font-black uppercase tracking-tight">
        Your wishlist is empty
      </h2>

      <p className="mx-auto mt-3 max-w-md text-sm leading-7 text-muted-foreground">
        Save your favorite products and return anytime.
      </p>

      <Link
        href="/shop"
        className="mt-8 inline-flex rounded-full bg-foreground px-6 py-3 text-sm font-bold text-background"
      >
        Start Shopping
      </Link>
    </div>
  );
}